import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { Router } from "@angular/router";
import { GameReportByProvider } from "src/_models";
import { FormControl } from "@angular/forms";
import { User } from "src/_models";
import { SapRoles, roleTypeSap } from "src/_constants/roleType";
import { Category } from "src/_models/bet";

@Component({
  selector: "app-game-report",
  templateUrl: "./game-report.component.html",
  styleUrls: ["./game-report.component.scss"],
})
export class GameReportComponent implements OnInit {
  datalistDisplayedColumns: string[] = [
    "ProviderId",
    "TotalBets",
    "TotalAmount",
    "TotalCommission",
    "TotalCancel",
    "TotalLost",
    "TotalWon",
    "ToTalCashedOut",
    "CashedOutAmount",
    "TotalProfit",
  ];
  providers: any = [];
  premiumdisplayName = "";
  selected: any = {
    startDate: new Date().setHours(0, 0, 0, 0),
    endDate:
      Number(new Date().setHours(23, 59, 59).toString().slice(0, 10)) * 1000,
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  cgProviders: any = JSON.parse(sessionStorage.getItem("category"));
  datalist = new MatTableDataSource<GameReportByProvider>();
  selectedUserName = "";
  selectedUser: { userId: string; userName: string };
  users: User[] = [];
  filterUsers: User[] = [];
  ProviderId: string = "all";
  OperatorId = new FormControl([]);
  operatorData = [];
  sapRoles = SapRoles;
  dropdownSettings: any = {};
  statusSettings: any = {};
  originSettings: any = {};
  origin = new FormControl([]);
  category = new FormControl([]);
  origins = ["SPORTSBOOK","PREMIUM","VIRTUAL","EXPREMIUM"];
  categories = Category;
  show = false;
  subProviders = ["TPremium"];
  subProvider = new FormControl([]);

  // formDate = new FormControl(this.today);
  // toDate = new FormControl(new Date(this.today.getTime() + 86400000));
  constructor(private appService: AppService, private router: Router) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "operator_id",
      textField: "operator_id",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.statusSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.originSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.getOurProviders();
    this.getReportData();
    this.getOperatorData();
    if (roleTypeSap.includes(this.userRole.role) || this.cgProviders.includes("SportsBook")) {
      this.show = true;
    }
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators.sort((a, b) => {
            let fa = a.operator_id.toLowerCase(),
              fb = b.operator_id.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedOperatorId = (OperatorId) => {
    // this.page = 1
    this.OperatorId.setValue([OperatorId[0].operator_id]);
    this.getReportData();
    // this.paginator.pageIndex = 0
  };

  onUserSelection(user: any) {
    this.selectedUser = user;
    this.getReportData();
  }

  onUserSelectionClear() {
    this.selectedUser = null;
    // this.userAccStmt.data = null;
  }

  onSelectedProvider = (pid) => {
    this.ProviderId = pid;
    this.getReportData();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  getReportData = () => {
    try {
      let filters = {
        userId: this.selectedUser ? this.selectedUser.userId : null,
        origin: this.origin.value.length != 0 ? this.origin.value : [],
        category: this.category.value.length != 0 ? this.category.value[0].id : "",
        subProvider: this.subProvider.value.length != 0 ? this.subProvider.value[0] : "",
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
        status: "", 
        operatorId: this.OperatorId.value.length === 0 ? "" : this.OperatorId.value[0],
      };
      this.appService.getGameReport(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          console.log("origin",filters.origin)
            let lowerCaseOrigins = filters.origin.map(item => item.toLowerCase());
            this.premiumdisplayName = lowerCaseOrigins.length > 0 ? lowerCaseOrigins.join(', ') : "";
          this.datalist = new MatTableDataSource<GameReportByProvider>(
            res.providerGamesReports
          );
        }
      });
    } catch (err) {}
  };

  goToProviderLevel = (row: GameReportByProvider) => {
    this.router.navigate([`reports/game_report/${row.providerId}`], {
      queryParams: {
        providerId: row.providerId,
        userName: this.selectedUser ? this.selectedUser.userName : null,
        userId: this.selectedUser ? this.selectedUser.userId : null,
        origin: this.origin.value.length != 0 ? this.origin.value : [],
        category: this.category.value.length != 0 ? this.category.value[0].id : "",
        subProvider: this.subProvider.value.length != 0 ? this.subProvider.value[0] : "",
        operatorId: this.OperatorId.value.length === 0 ? "" : this.OperatorId.value[0],
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      },
    });
  };
}
